import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { icon } from "../../../components/assets/assets";
import AmpleHireImageTag from "../../../components/ample-hire-html-tags/ample-hire-image-tag";
import { setLogout } from "../../../redux/slices/signin-slice";
import { clearInterviewSlice } from "../../../redux/slices/interview-slice";

const InterviewComplete = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Prevent navigating back
    window.history.pushState(null, null, window.location.href);

    const handlePopState = (event) => {
      // Redirect user to login route
      navigate("/signin", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    dispatch(clearInterviewSlice());
    dispatch(setLogout());
  }, []);

  return (
    <div className="container vide-robo-wrapper">
      <div className="robo-outwrapper">
        <div className="ln-infog">
          {/* <img src="images/undraw_super_thank_you_re_f8bo-2.svg" alt="" /> */}
          <AmpleHireImageTag imgSrc={icon.thankYouSvg} altText="thank you" />
        </div>
        <div className="robo-lang-wrapper thank-wr">
          <h3 style={{ fontSize: "24px", fontWeight: "700", color: "var(--text-primary)", marginBottom: "12px" }}>Interview Complete</h3>
          <p style={{ fontSize: "16px", color: "var(--text-secondary)", marginBottom: "8px" }}>Thank you for completing your interview.</p>
          <p style={{ fontSize: "14px", color: "var(--text-secondary)", marginBottom: "16px" }}>
            Track your interview status by signing in to your account.
          </p>
          <Link to="/signin" replace style={{
            display: "inline-block",
            padding: "12px 32px",
            background: "var(--primary-color)",
            color: "#fff",
            borderRadius: "var(--radius-pill)",
            fontWeight: "600",
            fontSize: "14px",
            textDecoration: "none"
          }}>
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InterviewComplete;
